<template>
	<bsh-modal 
		titulo="Gerar PDF"
		tamanho="modal-md"
		:name="name">
		<template v-slot:default>
			<div class="form-group">
				<label class="font-weight-bold mb-3">Selecione a versão do PDF:</label>
				<div class="custom-control custom-radio mb-3">
					<input 
						type="radio" 
						id="pdf_pedido" 
						name="tipo_pdf" 
						value="pedido" 
						v-model="tipo" 
						class="custom-control-input">
					<label class="custom-control-label" for="pdf_pedido">
						<strong>Pedido</strong> — Sem valores
					</label>
				</div>
				<div class="custom-control custom-radio">
					<input 
						type="radio" 
						id="pdf_cliente" 
						name="tipo_pdf" 
						value="cliente" 
						v-model="tipo" 
						class="custom-control-input">
					<label class="custom-control-label" for="pdf_cliente">
						<strong>Cliente</strong> — Com valores
					</label>
				</div>
			</div>
	    </template>
	    <template v-slot:footer>
        	<button 
				ref="btnRequest"
        		type="button" 
        		class="btn btn-primary" 
        		@click="gerar">
        		<i class="fas fa-file-pdf mr-2"></i>Gerar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	export default {
		data(){
			return {
				name: 'gerar_pdf_pedido',
				tipo: 'pedido'
			}
		},
		methods: {
			gerar(){
				var url = this.tipo === 'pedido' 
					? this.$url+'/api/adm/pedidos/pdf-sem-valor/'+this.$route.params.id 
					: this.$url+'/api/adm/pedidos/pdf/'+this.$route.params.id;

				var link = document.createElement("a");
				link.setAttribute('download', null);
				link.href = url;
				document.body.appendChild(link);
				link.click();
				link.remove();

				$('#'+this.name).modal('hide');
			}
		}
	}
</script>